import { useQuery } from '@tanstack/react-query';
import { TimezoneService } from '../services/timezone';
import { IBaseUseQueryProps } from '../interfaces/baseUseQueryProps';
import { ITimezone } from '../interfaces/timezone';

export const GET_TIMEZONES_QUERY_KEY = 'get-timezone-list';
export const useGetTimezones = (props?: IBaseUseQueryProps<ITimezone[]>) => useQuery({
  queryKey: [GET_TIMEZONES_QUERY_KEY],
  queryFn: () => TimezoneService.getList(),
  refetchOnWindowFocus: false,
  staleTime: Number.MAX_SAFE_INTEGER,
  ...props
});